// src/components/ModelCard/ModelPreview.jsx
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './ModelPreview.module.scss';

function ModelPreview({ src, nombre, onClose }) {
  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  return ReactDOM.createPortal(
    <div
      className={`${styles.overlay} ${isVisible ? styles.show : styles.hide}`}
      onClick={handleClose}
    >
      <div className={styles.modal} onClick={e => e.stopPropagation()}>

        <button
          className={styles.closeButton}
          onClick={handleClose}
          aria-label="Cerrar vista previa"
        >
          &times;
        </button>

        <img
          src={src}
          alt={`Preview de ${nombre}`}
          width="900"
          height="600"
          className={styles.image}
        />
      </div>
    </div>,
    document.body
  );
}

export default ModelPreview;
